import { render } from "./IntelligentExtractCard.vue?vue&type=template&id=08d72c23&scoped=true"
import script from "./IntelligentExtractCard.vue?vue&type=script&lang=js"
export * from "./IntelligentExtractCard.vue?vue&type=script&lang=js"

import "./IntelligentExtractCard.vue?vue&type=style&index=0&id=08d72c23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d72c23"]])

export default __exports__